import { BLUE, DARK_GREY } from "../Constant/ColorConstant";

export const pageNotFoundStyle = {
  uploadedBtn: {
    width: "auto",
  },
  mainGrid: {
    flexDirection: "column",
    marginTop: "0rem",
    alignItems: "center",
    justifyContent: "center",
  },
  DescriptionOutlinedIconStyle: {
    fontSize: "12rem",
    color: DARK_GREY,
    opacity: "0.5",
  },
  SearchIconStyle: {
    position: "absolute",
    fontSize: "7rem",
    opacity: "0.9",
    marginRight: "5rem",
    left: "50%",
    right: "50%",
    transform: "translate(  -6rem,7.3rem)",
  },
  contentBoxStyle: {
    textAlign: "center",
    marginTop: "1rem",
  },
  notFoundStyle: {
    fontSize: "2rem",
    fontFamily: "Poppins",
    color: BLUE,
  },
  notFoundContentStyle: {
    fontSize: "0.938rem",
    fontFamily: "Poppins",
    color: BLUE,
    textAlign: "center",
    padding:"0 1rem"
  },
};
